import { useMemo } from "react";

import { Outlet } from "react-router-dom";
import { useAuth } from "context/AuthContext";

import brand from "assets/images/logo-avipair.png";
import SoftBox from "components/SoftBox";
import DashboardLayoutContainer from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Sidenav from "examples/Sidenav";

import { useSoftUIController } from "context";
import GuestRouteGuard from "components/GuestRouteGuard";
import { guestDemoNavRoutes } from "./utils/guestDemoNav";
import { transformProfileMenuToRoutes } from "./utils/menuUtils";

function isPricingRoute(route) {
  if (!route) return false;
  return (
    route.key === "pricing" ||
    route.route === "/dashboard/pricing" ||
    String(route.name || "").toLowerCase() === "pricing"
  );
}

function DashboardLayout() {
  const [controller] = useSoftUIController();
  const { sidenavColor } = controller;
  const auth = useAuth();

  // Sidebar menu from getUserProfile (profile.feature) only. Role/entityType source of truth = token.
  // Pricing is intentionally not shown in the sidenav.
  const portalRoutes = useMemo(() => {
    if (auth.isGuest) {
      return guestDemoNavRoutes.filter((r) => !isPricingRoute(r));
    }
    let routes = [];
    if (
      auth.profile?.feature &&
      Array.isArray(auth.profile.feature) &&
      auth.profile.feature.length > 0
    ) {
      routes = transformProfileMenuToRoutes(auth.profile.feature);
    }
    return routes.filter((r) => !isPricingRoute(r));
  }, [auth.isGuest, auth.profile?.feature]);

  return (
    <>
      {/* Fills the gap above the sticky AppBar (navbar styles use top: 12px). Without this, page content
          scrolls behind that strip and is visible between the viewport top and the bar. Navbar position unchanged. */}
      <SoftBox
        aria-hidden
        sx={(theme) => ({
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: theme.functions.pxToRem(62),
          zIndex: theme.zIndex.appBar - 1,
          bgcolor: theme.palette.background.default ?? theme.palette.grey[100],
          pointerEvents: "none",
        })}
      />
      <Sidenav
        color={sidenavColor}
        brand={brand}
        brandName="AviPair"
        routes={portalRoutes}
      />
      <DashboardLayoutContainer>
        <DashboardNavbar />
        <SoftBox
          component="main"
          sx={{
            position: "relative",
            zIndex: 0,
            width: "100%",
            minWidth: 0,
            py: { xs: 2, sm: 2.5 },
            pt: { xs: 2, sm: 2.5 },
          }}
        >
          <GuestRouteGuard>
            <Outlet />
          </GuestRouteGuard>
        </SoftBox>
      </DashboardLayoutContainer>
    </>
  );
}

export default DashboardLayout;
